/* eslint-disable jsx-a11y/anchor-is-valid */
import labelKey from "../../../../../localization/label.json"

type Props = {
  formik: any
  isTravelModuleAccessAvailable?: boolean
  /** Manager review: User Details uses same 6-column grid as Address Detail. */
  requestedByManager?: boolean
}

const ReviewField = ({ label, value }: { label: string; value?: any }) => (
  <div className='col-6 col-md-4 col-lg-2 mb-3'>
    <p className='fw-bold fs-7 mb-1'>{label}</p>
    <span className='fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input'>
      {value !== null && value !== undefined && value !== '' ? value : '—'}
    </span>
  </div>
)

const Step4 = ({ formik, isTravelModuleAccessAvailable = false, requestedByManager = false }: Props) => {
  const showFlexBudget =
    formik.values.requestingAccountFor?.id === 2 &&
    (formik.values.expenseType?.id === 1 || formik.values.expenseType?.id === 3)

  return (
    <>
      <div data-kt-stepper-element='content' className="overflow-auto overflow-x-hidden" style={{ height: "65vh" }}>
        <div className='w-100'>
          <h1 className='fw-bold text-gray-800 mb-15 text-center'>{labelKey.review}</h1>

          <div className="row">
            <div className="col-md-12">
              <h3 className="mb-5">User Details</h3>
            </div>

            {requestedByManager ? (
              <>
                <ReviewField label='Expense Account Type' value={formik.values.expenseType?.value} />
                {showFlexBudget && <ReviewField label='Users Flex Budget $' value={formik.values.flexBudget} />}
                <ReviewField label='User Type' value={formik.values.userType?.value} />
                {!!isTravelModuleAccessAvailable && (
                  <ReviewField label='Travel Portal Access' value={formik.values.requestTravelPortalAccess ? 'Yes' : 'No'} />
                )}
                <ReviewField label='Corporate Credit Card' value={formik.values.requestCorporateCreditCard ? 'Yes' : 'No'} />
                {formik.values.requestCorporateCreditCard && (
                  <ReviewField label='Corp CC Limit' value={formik.values.spendingLimit || 'N/A'} />
                )}
                <ReviewField label={labelKey.manager} value={formik.values.managerName} />
                <ReviewField
                  label={formik.values.requestCorporateCreditCard ? 'Ship To Address' : labelKey.officeLocation}
                  value={formik.values.location?.value}
                />
                <ReviewField label={labelKey.department} value={formik.values.department?.title} />
                <ReviewField label={labelKey.division} value={formik.values.division?.title} />
                <ReviewField label={labelKey.designation} value={formik.values.designation?.title} />
                <ReviewField label={labelKey.email} value={formik.values.userName} />
                <ReviewField label={labelKey.firstName} value={formik.values.firstName} />
                <ReviewField label={labelKey.middleName} value={formik.values.middleName} />
                <ReviewField label={labelKey.lastName} value={formik.values.lastName} />
                <ReviewField label={labelKey.cellPhone} value={formik.values.cellPhone} />
                <ReviewField label={labelKey.businessPhone} value={formik.values.businessPhone} />
                <ReviewField label={labelKey.businessExt} value={formik.values.businessExt} />
                <ReviewField label={labelKey.timeZone} value={formik.values.userTimeZone?.title} />
                <ReviewField label='Dayforce ID' value={formik.values.dayforceId} />
              </>
            ) : (
              <>
                <div className="col-md-12 col-lg-6 col-xl-6">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">Expense Account Type:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.expenseType.value}</span>
                    </div>
                  </div>
                  {showFlexBudget &&
                    <div className="row align-items-center mb-3">
                      <div className="col-md-3 col-lg-4">
                        <p className="fw-bold fs-6 mb-0">Users Flex Budget $:</p>
                      </div>
                      <div className="col-md-8">
                        <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.flexBudget}</span>
                      </div>
                    </div>}
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">User Type:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.userType.value}</span>
                    </div>
                  </div>
                  {!!isTravelModuleAccessAvailable && (
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">Request Travel Portal Access:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.requestTravelPortalAccess ? 'Yes' : 'No'}</span>
                    </div>
                  </div>
                  )}
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">Request Corporate Credit Card:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.requestCorporateCreditCard ? 'Yes' : 'No'}</span>
                    </div>
                  </div>
                  {formik.values.requestCorporateCreditCard && (
                    <div className="row align-items-center mb-3">
                      <div className="col-md-3 col-lg-4">
                        <p className="fw-bold fs-6 mb-0">Corp CC Limit:</p>
                      </div>
                      <div className="col-md-8">
                        <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.spendingLimit || 'N/A'}</span>
                      </div>
                    </div>
                  )}
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.manager}:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.managerName}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{formik.values.requestCorporateCreditCard ? 'Ship To Address' : labelKey.officeLocation}:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.location.value}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.department}:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.department.title}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.division}:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.division.title}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.designation}:</p>
                    </div>
                    <div className="col-md-8">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.designation.title}</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-6 col-xl-6">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.email}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.userName}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.firstName}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.firstName}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.middleName}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.middleName}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.lastName}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.lastName}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.cellPhone}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.cellPhone}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4 col-xl-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.businessPhone}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.businessPhone}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.businessExt}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.businessExt}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">{labelKey.timeZone}:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.userTimeZone?.title}</span>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-3 col-lg-4">
                      <p className="fw-bold fs-6 mb-0">Dayforce ID:</p>
                    </div>
                    <div className="col-md-8 col-xl-7">
                      <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.dayforceId}</span>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="col-12">
              <div className="ms-10">
                <hr />
              </div>
              <h3 className="mb-4">Address Detail</h3>
            </div>
            <div className="col-12 col-lg-6 mb-3">
              <div className="row align-items-center">
                <div className="col-auto pe-2">
                  <p className="fw-bold fs-7 mb-0">{labelKey.findAddress}:</p>
                </div>
                <div className="col">
                  <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values?.findAddress}</span>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3 mb-3">
              <div className="row align-items-center">
                <div className="col-12">
                  <p className="fw-bold fs-7 mb-1">{labelKey.addressLine1}</p>
                  <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.addressLine1}</span>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-4 col-lg-3 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.addressLine2}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.addressLine2 || '—'}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.city}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.city}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.state}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.state}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.country}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.country?.title || '—'}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.postalCode}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.postalCode}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.latitude}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.latitude}</span>
            </div>
            <div className="col-6 col-md-4 col-lg-2 mb-3">
              <p className="fw-bold fs-7 mb-1">{labelKey.longitude}</p>
              <span className="fs-7 text-gray-900 form-control form-control-sm form-control-solid default-input">{formik.values.longitude}</span>
            </div>
          </div>
        </div>
      </div >
    </>
  )
}

export { Step4 };
